import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { EmployerBasicDetails } from "./BasicsAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const EmployerBasicsAsync = createAsyncThunk(
  "EmployerBasics/add",
  async (details) => {
    try {
      const data = await EmployerBasicDetails(details);
      // console.log("data in slice", data);
      return data.response;
    } catch (error) {
      // console.log("errorL :", error);
      return(error.message);
      // return rejectWithValue(error.message);
    }
  }
);


const EmployerBasicsSlice = createSlice({
  name: "EmployerBasics",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      
      .addCase(EmployerBasicsAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(EmployerBasicsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add ";
      })
      
  },
});

export const selectEmployer = (state) => state.employerBasics.data;

export default EmployerBasicsSlice.reducer;
